import { render, staticRenderFns } from "./diseaseChart.vue?vue&type=template&id=1438d86c&scoped=true"
import script from "./diseaseChart.vue?vue&type=script&lang=js"
export * from "./diseaseChart.vue?vue&type=script&lang=js"
import style0 from "./diseaseChart.vue?vue&type=style&index=0&id=1438d86c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1438d86c",
  null
  
)

export default component.exports